import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment.development';
import { ConsentModel } from '../../common/Models/ConsentModel';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpNoInterceptorService } from '../../common/services/http-no-interceptor-service.service';
@Injectable({
  providedIn: 'root',
})
export class HomeService {
  constructor(
    private http: HttpClient,
    private httpNoInterceptor: HttpNoInterceptorService // Inject custom service
  ) {}

  // API URL

  private urlWebsiteStructure: string =
    environment.MasterAPI + 'WebsiteStructure/AboutData';
  private urlGrievanceFileUpload: string =
    environment.GrievanceAPI + 'Grievance/UploadAttachement';
   private urlAddGrievance: string =
    environment.GrievanceAPI + 'Grievance/AddCitizenGrievance';
  private urlAddGrievanceWithoutLogin: string =
    environment.GrievanceAPI + 'Grievance/AddCitizenGrievanceWithoutLogin';
  private urlCommonDropdownData: string =
    environment.GrievanceAPI + 'Grievance/GetDropDownData';
  private urlGetDistrictData: string =
    environment.GrievanceAPI + 'Grievance/GetDistrict';
  private urlSendOTP: string = environment.CommonAPI + 'sms/generateOTP';
  private urlVerifyOTP: string = environment.CommonAPI + 'SMS/VerifyOTP';
  private urlGetCitizenGrievance: string =
    environment.GrievanceAPI + 'Grievance/GetCitizenGrievanceWithoutLogin';
  private urlUpdateGrievance: string =
    environment.GrievanceAPI + 'Grievance/UpdateGrievanceWithoutLogin';
  private urlGetCaptcha: string =
    environment.CommonAPI + 'Captcha/get-captcha-image';
    private urlVerifyCaptcha: string =
    environment.CommonAPI + 'Captcha/verify-captcha-image';
  private urlCheckReopenAndSFC: string =
    environment.GrievanceAPI + 'Grievance/CheckReopenAndSFC';
  private urlSchemeDetailFilterd: string =
    environment.CMSAPI + 'CitizenHome/GetSchemeDetailCitizen?datacheckid=1';
  private urlSchemeDetail: string =
    environment.CMSAPI + 'CitizenHome/GetSchemeDetailCitizen?datacheckid=2';
  private urlSchemeDetailById: string =
    environment.CMSAPI + 'SchemeCreation/GetSchemeDetailData?selectedschemeid=';

  private urlDownloadAttachment: string =
    environment.GrievanceAPI + 'Grievance/DownloadAttachement?name=';

  // CMS EndPoints
      private urlCmsDignitaries: string =
      environment.CMSAPI + 'CitizenHome/GetDignitaries';
      private urlCMSAboutSection: string =
      environment.CMSAPI + 'CitizenHome/GetAboutus';
      private urlAboutMHUDCH: string =
      environment.CMSAPI + 'CitizenHome/GetAboutMHUCDH';
      private urlCMSIntegratedSection: string =
      environment.CMSAPI + 'CitizenHome/GetIntegratedApplication';
      private urlCMSPhotoGallery: string =
      environment.CMSAPI + 'CitizenHome/GetPhotoGallery';
      private urlCMSVideoGallery: string =
      environment.CMSAPI + 'CitizenHome/GetVideoGallery';
      private urlCMSUserManual: string =
      environment.CMSAPI + 'CitizenHome/GetUserManual?check=1';
      private urlCMSUserManualVideo: string =
      environment.CMSAPI + 'CitizenHome/GetVideoDemonstration?check=1';
      private urlCMSContactUs: string =
      environment.CMSAPI + 'CitizenHome/GetContactus';
      private urlCMSGeneralFAQs: string =
      environment.CMSAPI + 'CitizenHome/GetGeneralFAQs';
      private urlCMSSchemeWiseFAQs: string =
      environment.CMSAPI + 'CitizenHome/GetSchemeWiseFAQs';
      private urlCMSFooterSection: string =
      environment.CMSAPI + 'CitizenHome/GetQuickLinkFooter';
      private urlSendEmailOTP: string = environment.CommonAPI + 'sms/EmailSendOTP';
      private urlVerifyEmailOTP: string = environment.CommonAPI + 'sms/VerifyEmailOTP';
      private urlAddFeedback: string = environment.GrievanceAPI + 'Grievance/AddFeedback';
      private urlFetchVideoSummary :string = environment.MasterAPI + 'CitizenAIBot/FetchVideoSummary';
      private urlFetchVideoTranscriptions:string = environment.MasterAPI + 'CitizenAIBot/FetchVideoTranscriptions';
      private urlChatVideo:string = environment.MasterAPI + 'CitizenAIBot/ChatVideo';
      private urlChatAI:string = environment.MasterAPI + 'CitizenAIBot/ChatAIBot';
      private urlGetTaluka: string = environment.CMSAPI + 'OrganizationStructure/GetOrganizationTalukaByDistricts?districtids=';
      private urlGetVillage: string = environment.CMSAPI + 'OrganizationStructure/GetOrganizationVillagesByTalukas?talukaids=';
      private urlGetcountapplication:string = environment.GrievanceAPI + 'Grievance/Getcountapplication';
      private urlSendWhatsAppMessageAsync: string = environment.CommonAPI + 'sms/SendWhatsAppMessageAsync';

      private urlsetCaptchaRedis: string = environment.GrievanceAPI + 'Setexpiryvalue';
      private urlCMSBanner: string =  environment.CMSAPI + 'CmsBanner/GetBanner';
      private urlCMSAboutusmarathi: string =  environment.CMSAPI + 'CmsAboutus/CitizenGetAboutus';


    getWebsiteStructure(Body: ConsentModel) {
    return this.http.post(this.urlWebsiteStructure, Body);
  }

  grievanceFileUpload(Body: any) {
    return this.http.post(this.urlGrievanceFileUpload, Body);
  }

  addGrievance(Body: any) {
    return this.http.post(this.urlAddGrievance, Body);
  }
  addGrievanceWithoutLogin(Body:any){
    return this.http.post(this.urlAddGrievanceWithoutLogin, Body);
  }

  commonDropdownData(Body: any) {
    return this.httpNoInterceptor.post(this.urlCommonDropdownData, Body);
  }

  sendOTP(Body: any) {
    return this.http.post(this.urlSendOTP, Body);
  }
  private handleError(error: any): Observable<never> {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
  verifyOTP(Body: any) {
    return this.http.post(this.urlVerifyOTP, Body);
  }

  getDistrictDetials() {
    return this.http.get(this.urlGetDistrictData);
  }

  // Reddis Functions

  getDignitories(Body: any) {
    return this.http.get(this.urlCmsDignitaries, Body);
  }

  getAboutSection(Body: any) {
    return this.http.get(this.urlCMSAboutSection, Body);
  }

  getIntegratedSection(Body: any) {
    return this.http.get(this.urlCMSIntegratedSection, Body);
  }

  getAboutMHUCDHSection(Body: any) {
    return this.http.get(this.urlAboutMHUDCH, Body);
  }

  getPhotoGallery(Body: any) {
    return this.http.get(this.urlCMSPhotoGallery, Body);
  }

  getVideoGallery(Body: any) {
    return this.http.get(this.urlCMSVideoGallery, Body);
  }

  getUserManual(Body: any) {
    return this.http.get(this.urlCMSUserManual, Body);
  }

  getUserManualVideo(Body: any) {
    return this.http.get(this.urlCMSUserManualVideo, Body);
  }

  getContactUs(Body: any) {
    return this.http.get(this.urlCMSContactUs, Body);
  }

  getGeneralFAQs(Body: any) {
    return this.http.get(this.urlCMSGeneralFAQs, Body);
  }

  getSchemeWiseFAQs(Body: any) {
    return this.http.get(this.urlCMSSchemeWiseFAQs, Body);
  }

  getFooterSection(Body: any) {
    return this.http.get(this.urlCMSFooterSection, Body);
  }

  getCitizenGrievance(Body: any) {
    return this.http.post(this.urlGetCitizenGrievance, Body);
  }

  updateGrievance(Body: any) {
    return this.http.post(this.urlUpdateGrievance, Body);
  }

  getCaptcha() {
    return this.http.get(this.urlGetCaptcha);
  }

  verifyCaptcha(Body: any) {
    return this.http.post(this.urlVerifyCaptcha, Body);
  }

  downloadAttachment(url: string) {
    return this.http.get(this.urlDownloadAttachment + url);
  }

  validateGrievanceStatus(Body: any) {
    return this.http.post(this.urlCheckReopenAndSFC, Body);
  }

  schemeDetailFilterd() {
    return this.http.get(this.urlSchemeDetailFilterd);
  }

  schemeDetails() {
    return this.http.get(this.urlSchemeDetail);
  }

  schemeDetailsById(id: string) {
    return this.http.get(this.urlSchemeDetailById + id);
  }
  sendEmailOTP(toEmail: string): Observable<any>{
    const params = new HttpParams().set('toEmail', toEmail);
    return this.http.post<any>(this.urlSendEmailOTP, {}, { params: params });
  }
  verifyEmailOTP(toEmail: string,otp:string): Observable<any>{
    const params = new HttpParams()
      .set('toEmail', toEmail)
      .set('otp', otp);
    return this.http.post<any>(this.urlVerifyEmailOTP, {}, { params: params });
  }
  addFeedback(data: any) :Observable<any> {
     return this.http.post(this.urlAddFeedback , data );
  }
  fetchVideoSummary(id: string) {
    return this.http.get(`${this.urlFetchVideoSummary}?id=${id}`);
}

fetchVideoTranscriptions(id: string) {
    return this.http.get(`${this.urlFetchVideoTranscriptions}?id=${id}`, {});
}

fetchChatVideo(id: string, question: string,chatid:string,userid:string) {
  return this.http.post(`${this.urlChatVideo}?id=${encodeURIComponent(id)}&question=${encodeURIComponent(question)}&chatid=${encodeURIComponent(chatid)}&userid=${encodeURIComponent(userid)}`, {});
}
fetchChatAI(question:string){
  return this.http.post(`${this.urlChatAI}?question=${question}`, {});
}
getTaluka(id: number | string) {
  return this.http.get(`${this.urlGetTaluka}${id}`);
}

getVillage(id: number | string) {
  return this.http.get(`${this.urlGetVillage}${id}`);
}
getCounterData() {
  return this.http.get(`${this.urlGetcountapplication}`);
}
  SendWhatsAppMessageAsync(Body: any) {
    return this.http.post(this.urlSendWhatsAppMessageAsync, Body);
}

  setCaptchaRedis(Body: any) {
    return this.http.post(this.urlsetCaptchaRedis, Body);
  }

private urlgetCircularsData: string = environment.CMSAPI + 'CitizenHome/GetCircularsData?check=1';
getCircularsData(){
  return this.http.get(this.urlgetCircularsData);
};

GetBanner() {
  return this.http.get(this.urlCMSBanner);
}

GetAboutmarathiData() {
  return this.http.get(this.urlCMSAboutusmarathi);
}

}
